<!-- Header con título y acciones -->
<div class="bg-white shadow-lg rounded-lg p-6 mb-6">
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between">
    <div>
      <h1 class="text-2xl font-bold text-gray-900 mb-2">Rastreo de Emails Enviados</h1>
      <p class="text-gray-600">Historial y seguimiento de todos los correos enviados por el sistema</p>
    </div>

    <div class="flex items-center space-x-3 mt-4 sm:mt-0">
      <button
        (click)="downloadLogs()"
        [disabled]="emailLogs.length === 0"
        class="flex items-center px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors disabled:bg-gray-400">
        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
        </svg>
        Descargar
      </button>
    </div>
  </div>
</div>

<!-- Filtros rápidos -->
<div class="bg-white shadow rounded-lg p-4 mb-6">
  <div class="flex flex-wrap gap-2">
    <button
      (click)="setQuickFilter('success')"
      class="px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm hover:bg-green-200 transition-colors">
      Exitosos
    </button>

    <button
      (click)="setQuickFilter('errors')"
      class="px-3 py-1 bg-red-100 text-red-700 rounded-full text-sm hover:bg-red-200 transition-colors">
      Con Error
    </button>

    <button
      (click)="setQuickFilter('reminders')"
      class="px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-sm hover:bg-orange-200 transition-colors">
      Recordatorios
    </button>

    <button
      (click)="setQuickFilter('payment-links')"
      class="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm hover:bg-blue-200 transition-colors">
      Links de Pago
    </button>

    <button
      (click)="setQuickFilter('today')"
      class="px-3 py-1 bg-indigo-100 text-indigo-700 rounded-full text-sm hover:bg-indigo-200 transition-colors">
      Hoy
    </button>

    <button
      (click)="setQuickFilter('week')"
      class="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-sm hover:bg-purple-200 transition-colors">
      Última Semana
    </button>

    <button
      (click)="clearFilters()"
      class="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-sm hover:bg-gray-200 transition-colors">
      Limpiar Filtros
    </button>
  </div>
</div>

<!-- Panel de filtros -->
<div class="bg-white shadow rounded-lg p-6 mb-6">
  <div class="flex items-center justify-between mb-4">
    <h3 class="text-lg font-medium text-gray-900">Filtros de Búsqueda</h3>
    <button
      (click)="showFilters = !showFilters"
      class="text-blue-600 hover:text-blue-800">
      {{ showFilters ? 'Ocultar' : 'Mostrar' }} Filtros
    </button>
  </div>

  <div *ngIf="showFilters" class="space-y-4">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <!-- Búsqueda por email destinatario -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Email del Destinatario</label>
        <input
          type="text"
          (input)="onSearch($event)"
          placeholder="Ej: usuario@ejemplo.com"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500">
      </div>

      <!-- Filtro por tipo de email -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Tipo de Email</label>
        <select
          [(ngModel)]="filters.emailType"
          (change)="applyFilters()"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500">
          <option [ngValue]="undefined">Todos los tipos</option>
          <option *ngFor="let type of emailTypeOptions" [ngValue]="type.value">{{ type.label }}</option>
        </select>
      </div>

      <!-- Filtro por estado -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Estado</label>
        <select
          [(ngModel)]="filters.isSuccess"
          (change)="applyFilters()"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500">
          <option [ngValue]="undefined">Todos</option>
          <option [ngValue]="true">Exitoso</option>
          <option [ngValue]="false">Error</option>
        </select>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <!-- Fecha desde -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Fecha Desde</label>
        <input
          type="date"
          [(ngModel)]="dateFrom"
          (change)="applyFilters()"
          [max]="maxDate | date:'yyyy-MM-dd'"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500">
      </div>

      <!-- Fecha hasta -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Fecha Hasta</label>
        <input
          type="date"
          [(ngModel)]="dateTo"
          (change)="applyFilters()"
          [max]="maxDate | date:'yyyy-MM-dd'"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500">
      </div>

      <!-- Filtro por PaymentLinkId -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">ID Link de Pago</label>
        <input
          type="number"
          [(ngModel)]="filters.paymentLinkId"
          (change)="applyFilters()"
          placeholder="Ej: 123"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500">
      </div>

      <!-- Tamaño de página -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Elementos por Página</label>
        <select
          (change)="onPageSizeChange($event)"
          [value]="pageSize"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500">
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>
    </div>
  </div>
</div>

<!-- Indicador de carga -->
<div *ngIf="loading" class="text-center py-8">
  <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
  <p class="mt-2 text-gray-600">Cargando logs de emails...</p>
</div>

<!-- Mensaje de error -->
<div *ngIf="error" class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
  <div class="flex">
    <svg class="w-5 h-5 text-red-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"></path>
    </svg>
    <p class="text-red-700">{{ error }}</p>
  </div>
</div>

<!-- Tabla de logs -->
<div *ngIf="!loading && !error" class="bg-white shadow rounded-lg overflow-hidden">
  <div class="px-6 py-4 border-b border-gray-200">
    <div class="flex items-center justify-between">
      <h3 class="text-lg font-medium text-gray-900">
        Emails Enviados ({{ totalRecords | number }} registros)
      </h3>
      <div class="text-sm text-gray-500">
        Página {{ currentPage }} de {{ totalPages }}
      </div>
    </div>
  </div>

  <div class="overflow-x-auto">
    <table class="min-w-full divide-y divide-gray-200">
      <thead class="bg-gray-50">
        <tr>
          <th
            (click)="changeSort('SentAt')"
            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100">
            <div class="flex items-center">
              Fecha/Hora
              <svg *ngIf="filters.orderBy === 'SentAt'" class="w-4 h-4 ml-1"
                   [class.rotate-180]="filters.orderDirection === 'desc'"
                   fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"></path>
              </svg>
            </div>
          </th>

          <th
            (click)="changeSort('RecipientEmail')"
            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100">
            <div class="flex items-center">
              Destinatario
              <svg *ngIf="filters.orderBy === 'RecipientEmail'" class="w-4 h-4 ml-1"
                   [class.rotate-180]="filters.orderDirection === 'desc'"
                   fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"></path>
              </svg>
            </div>
          </th>

          <th
            (click)="changeSort('EmailType')"
            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100">
            <div class="flex items-center">
              Tipo
              <svg *ngIf="filters.orderBy === 'EmailType'" class="w-4 h-4 ml-1"
                   [class.rotate-180]="filters.orderDirection === 'desc'"
                   fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"></path>
              </svg>
            </div>
          </th>

          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Asunto
          </th>

          <th
            (click)="changeSort('IsSuccess')"
            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100">
            <div class="flex items-center">
              Estado
              <svg *ngIf="filters.orderBy === 'IsSuccess'" class="w-4 h-4 ml-1"
                   [class.rotate-180]="filters.orderDirection === 'desc'"
                   fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"></path>
              </svg>
            </div>
          </th>

          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Link de Pago
          </th>

          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Acciones
          </th>
        </tr>
      </thead>

      <tbody class="bg-white divide-y divide-gray-200">
        <tr *ngFor="let log of emailLogs; trackBy: trackByLogId"
            class="hover:bg-gray-50 transition-colors">

          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
            {{ emailLogService.formatDateTime(log.sentAt) }}
          </td>

          <td class="px-6 py-4 whitespace-nowrap">
            <div class="text-sm text-gray-900">{{ log.recipientEmail }}</div>
            <div *ngIf="log.recipientName" class="text-sm text-gray-500">{{ emailLogService.truncateText(log.recipientName, 30) }}</div>
          </td>

          <td class="px-6 py-4 whitespace-nowrap">
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                  [ngClass]="emailLogService.getEmailTypeClass(log.emailType)">
              {{ emailLogService.getEmailTypeLabel(log.emailType) }}
            </span>
          </td>

          <td class="px-6 py-4">
            <div class="text-sm text-gray-900 max-w-xs truncate" [title]="log.subject">
              {{ log.subject }}
            </div>
          </td>

          <td class="px-6 py-4 whitespace-nowrap">
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                  [ngClass]="emailLogService.getSuccessClass(log.isSuccess)">
              {{ log.isSuccess ? 'Enviado' : 'Error' }}
            </span>
          </td>

          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
            {{ log.paymentLinkId || 'N/A' }}
          </td>

          <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
            <button
              (click)="showDetail(log)"
              class="text-blue-600 hover:text-blue-900">
              Ver Detalle
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Mensaje cuando no hay datos -->
  <div *ngIf="emailLogs.length === 0" class="text-center py-12">
    <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
    </svg>
    <h3 class="mt-2 text-sm font-medium text-gray-900">No hay emails registrados</h3>
    <p class="mt-1 text-sm text-gray-500">No se encontraron registros con los filtros aplicados.</p>
  </div>
</div>

<!-- Paginación -->
<div *ngIf="!loading && !error && totalPages > 1" class="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6 mt-6 rounded-lg shadow">
  <div class="flex-1 flex justify-between items-center sm:hidden">
    <button
      (click)="onPageChange(currentPage - 1)"
      [disabled]="currentPage === 1"
      class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
      Anterior
    </button>

    <span class="text-sm text-gray-700">
      Página {{ currentPage }} de {{ totalPages }}
    </span>

    <button
      (click)="onPageChange(currentPage + 1)"
      [disabled]="currentPage === totalPages"
      class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
      Siguiente
    </button>
  </div>

  <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
    <div>
      <p class="text-sm text-gray-700">
        Mostrando
        <span class="font-medium">{{ (currentPage - 1) * pageSize + 1 }}</span>
        a
        <span class="font-medium">{{ Math.min(currentPage * pageSize, totalRecords) }}</span>
        de
        <span class="font-medium">{{ totalRecords }}</span>
        resultados
      </p>
    </div>

    <div>
      <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
        <button
          (click)="onPageChange(currentPage - 1)"
          [disabled]="currentPage === 1"
          class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
          <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd"/>
          </svg>
        </button>

        <button
          *ngFor="let page of getPageNumbers()"
          (click)="onPageChange(page)"
          [class]="page === currentPage ?
            'z-10 bg-blue-50 border-blue-500 text-blue-600' :
            'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'"
          class="relative inline-flex items-center px-4 py-2 border text-sm font-medium transition-colors">
          {{ page }}
        </button>

        <button
          (click)="onPageChange(currentPage + 1)"
          [disabled]="currentPage === totalPages"
          class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
          <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
          </svg>
        </button>
      </nav>
    </div>
  </div>
</div>

<!-- Modal de detalle del email log -->
<div *ngIf="showLogDetail && selectedLog"
     class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
  <div class="relative top-20 mx-auto p-5 border w-11/12 md:w-3/4 lg:w-1/2 shadow-lg rounded-md bg-white">
    <div class="flex items-center justify-between mb-4">
      <h3 class="text-lg font-bold text-gray-900">Detalle del Email Enviado</h3>
      <button
        (click)="closeDetail()"
        class="text-gray-400 hover:text-gray-600">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <div class="max-h-96 overflow-y-auto">
      <dl class="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <dt class="font-medium text-gray-900">ID</dt>
          <dd class="mt-1 text-gray-700">{{ selectedLog.id }}</dd>
        </div>

        <div>
          <dt class="font-medium text-gray-900">Fecha/Hora de Envío</dt>
          <dd class="mt-1 text-gray-700">{{ emailLogService.formatDateTime(selectedLog.sentAt) }}</dd>
        </div>

        <div>
          <dt class="font-medium text-gray-900">Tipo de Email</dt>
          <dd class="mt-1">
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                  [ngClass]="emailLogService.getEmailTypeClass(selectedLog.emailType)">
              {{ emailLogService.getEmailTypeLabel(selectedLog.emailType) }}
            </span>
          </dd>
        </div>

        <div>
          <dt class="font-medium text-gray-900">Estado</dt>
          <dd class="mt-1">
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                  [ngClass]="emailLogService.getSuccessClass(selectedLog.isSuccess)">
              {{ selectedLog.isSuccess ? 'Enviado Exitosamente' : 'Error en Envío' }}
            </span>
          </dd>
        </div>

        <div class="sm:col-span-2">
          <dt class="font-medium text-gray-900">Email del Destinatario</dt>
          <dd class="mt-1 text-gray-700 break-all">{{ selectedLog.recipientEmail }}</dd>
        </div>

        <div *ngIf="selectedLog.recipientName" class="sm:col-span-2">
          <dt class="font-medium text-gray-900">Nombre del Destinatario</dt>
          <dd class="mt-1 text-gray-700">{{ selectedLog.recipientName }}</dd>
        </div>

        <div class="sm:col-span-2">
          <dt class="font-medium text-gray-900">Asunto</dt>
          <dd class="mt-1 text-gray-700">{{ selectedLog.subject }}</dd>
        </div>

        <div>
          <dt class="font-medium text-gray-900">ID Link de Pago</dt>
          <dd class="mt-1 text-gray-700">{{ selectedLog.paymentLinkId || 'N/A' }}</dd>
        </div>

        <div>
          <dt class="font-medium text-gray-900">ID Template Mailjet</dt>
          <dd class="mt-1 text-gray-700">{{ selectedLog.templateId || 'N/A' }}</dd>
        </div>

        <div>
          <dt class="font-medium text-gray-900">Código Respuesta Mailjet</dt>
          <dd class="mt-1 text-gray-700">{{ selectedLog.mailjetStatusCode || 'N/A' }}</dd>
        </div>

        <div *ngIf="selectedLog.errorMessage" class="sm:col-span-2">
          <dt class="font-medium text-gray-900">Mensaje de Error</dt>
          <dd class="mt-1">
            <pre class="bg-red-50 text-red-800 p-3 rounded text-xs overflow-x-auto max-h-32 border border-red-200">{{ selectedLog.errorMessage }}</pre>
          </dd>
        </div>
      </dl>
    </div>

    <div class="mt-6 flex justify-end space-x-3">
      <button
        (click)="copyToClipboard(JSON.stringify(selectedLog, null, 2))"
        class="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
        Copiar JSON
      </button>

      <button
        (click)="closeDetail()"
        class="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 transition-colors">
        Cerrar
      </button>
    </div>
  </div>
</div>
